var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-66 md-xsmall-size-80 mx-auto"},[_c('create-administrator-form',{on:{"on-submit":_vm.onCreateAdministratorSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }